
<script type="text/javascript">
    import axios from 'axios';

    axios.defaults.baseURL = 'https://fyzhst.9313.tv/index.php'
    // axios.defaults.baseURL = 'http://192.168.0.29:8090/index.php'
    // axios.defaults.baseURL = global.host + '/index.php'
    // axios.defaults.baseURL = '/api'

    function _get(url, data, success, fail, checkLogin) {
      // 构造请求参数
      let _this = this;
      data = data || {};
      data.user_id = _this.getUserId();
      data.token = _this.getToken();
      // console.log(data)
      if(checkLogin){
        if(!data.user_id || !data.token){
          alert('请先登录！');
          //跳转登录页面
          _this.goLogin();
          return false;
        }
      }
      // console.log(data)
      // let param = {};
      // param.data = data;
      // param.data = cryptoJSObj.encrypt(JSON.stringify(data));
      // console.log(param.data)
      // console.log(cryptoJSObj.decrypt(param.data))
      // axios.get(url, {params: param}).then(function (response) {
      axios.get(url, {params: data}).then(function (response) {
        // console.log(response)
        // if (response.status == 401) {
        //   alert('未授权')
        //   _this.goLogin();
        //   return false;
        // }

        if ((response.status !== 200 && response.status !== 201)|| typeof response.data !== 'object') {
          response.msg = '网络请求出错_g';
          alert(response.msg)
          // alert(JSON.stringify(response))
          fail && fail(response);
          return false;
        }
        // console.log(response.data)
        // cryptoJSObj.decrypt(res.data)
        if (response.data.code == '0') {
          alert(response.data.msg)
          // alert(JSON.stringify(response))
          fail && fail(response.data);
          return false;
        } else if(response.data.code == '201') {
          // alert(response.data.msg)
          //跳转登录
          _this.goLogin();
          return false;
        } else {
          success && success(response.data);
        }
      }).catch(function (error) {
        error.msg = '网络请求出错_ge';
        // alert(error.msg)
        console.log(error)
        fail && fail(error);
      });
    }

    function _post(url, data, success, fail, checkLogin) {
      // 构造请求参数
      let _this = this;
      data = data || {};
      data.user_id = _this.getUserId();
      data.token = _this.getToken();
      if(checkLogin){
        if(!data.user_id || !data.token){
          alert('请先登录！');
          //跳转登录页面
          _this.goLogin();
          return false;
        }
      }
      // data = cryptoJSObj.encrypt(JSON.stringify(data));
      // axios.post(url, {data:data}).then(function (response) {
      axios.post(url, data).then(function (response) {
        if ((response.status !== 200 && response.status !== 201) || typeof response.data !== 'object') {
          response.msg = '网络请求出错_p';
          alert(response.msg)
          // alert(JSON.stringify(response))
          fail && fail(response);
          return false;
        }
        if (response.data.code == '0') {
          alert(response.data.msg)
          // alert(JSON.stringify(response))
          fail && fail(response.data);
          return false;
        } else if(response.data.code == '201') {
          // alert(response.data.msg)
          //跳转登录
          _this.goLogin();
          return false;
        } else {
          success && success(response.data);
        }
      }).catch(function (error) {
        error.msg = '网络请求出错_pe';
        alert(error.msg);
        // alert('msg'+error.msg)
        // alert('message'+error.message)
        // alert('name'+error.name)
        // alert('stack'+error.stack)
        // alert('code'+error.code)
        // alert('status'+error.status)
        // alert('config'+JSON.stringify(error.config))
        // alert(JSON.stringify(error))

        console.log(error);
        fail && fail(error);
      });

    }

    function goLogin(){
      //跳转登录页面
      window.location.href = '/#/Login';
      // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx502585b2e6d1db43&redirect_uri=http%3A%2F%2Flpdh.ahxunshi.cn%2findex%2Findex%2fthird?platform=wechat&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    }

    function checkLogin(){
      let that = this;
      let user_id = that.getUserId();
      let token = that.getToken();
      if(user_id==0 || token==0){
        return false;
      }else{
        return true;
      }
    }

    function getUserId() {
      return window.localStorage.getItem('user_id')?window.localStorage.getItem('user_id'):0;
    }

    function getToken() {
      return window.localStorage.getItem('token')?window.localStorage.getItem('token'):0;
    }

    // 暴露出这些属性和方法
    export default {
      // httpUrl,
      _get,
      _post,
      getUserId,
      getToken,
      checkLogin,
      goLogin
    }
</script>



// WEBPACK FOOTER //
// src/components/common/Common.vue